import { render, staticRenderFns } from "./password-login.vue?vue&type=template&id=374f985b&scoped=true"
import script from "./password-login.vue?vue&type=script&lang=js"
export * from "./password-login.vue?vue&type=script&lang=js"
import style0 from "./password-login.vue?vue&type=style&index=0&id=374f985b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374f985b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('374f985b')) {
      api.createRecord('374f985b', component.options)
    } else {
      api.reload('374f985b', component.options)
    }
    module.hot.accept("./password-login.vue?vue&type=template&id=374f985b&scoped=true", function () {
      api.rerender('374f985b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loginreg/password-login.vue"
export default component.exports